import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { NO_BIZ } from "MODULES/companies/constants";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function DoNotDoBusinessWarning({ company }) {
  return (
    get(company, "status") === NO_BIZ && (
      <Warning>
        This Company has been flagged as `Do Not Do Business`. Please proceed
        with caution.
      </Warning>
    )
  );
}

DoNotDoBusinessWarning.propTypes = {
  company: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/IncomingQuotes/Create/DoNotDoBusinessWarning.jsx